export default "__VITE_ASSET__C6i1OmDr__"